module.exports = __webpack_public_path__ + "static/media/uncuyo.85016349.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/uncuyo.png
// module id = 884
// module chunks = 0